import { Box, Paper } from '@mui/material';
import SearchFilters, {
  SearchFiltersPropsType,
} from '../search-filters/search-filters.component';
import { useSearchParamsContext } from '../search.hooks';
import SearchToolbarButtons from './search-toolbar-buttons/search-toolbar-buttons.component';
import SearchToolbarInput from './search-toolbar-input/search-toolbar-input.component';

type SearchToolbarPropsType = {
  searchInputLabel?: string;
  buttons?: React.ReactNode;
  showRefresh?: boolean;
  onRefreshClick?: () => void;
} & SearchFiltersPropsType;

const SearchToolbar = ({
  searchInputLabel,
  buttons,
  showRefresh = true,
  excludedFilters = [],
  onRefreshClick,
}: SearchToolbarPropsType) => {
  const { categories, queryParam, searchFilters } = useSearchParamsContext();

  const showSearchInput = Object.keys(categories).length > 0 || queryParam;

  return (
    <Box
      component={Paper}
      elevation={3}
      p={2}
      data-testid="SearchToolbar"
      display="flex"
      alignItems="center"
      flexWrap="wrap"
    >
      {showSearchInput && (
        <Box
          sx={{ width: { xs: '100%', sm: '400px' }, order: { xs: 2, md: 1 } }}
        >
          <SearchToolbarInput searchInputLabel={searchInputLabel} />
        </Box>
      )}

      {(!!buttons || showRefresh) && (
        <Box
          sx={{
            justifyContent: 'flex-end',
            flexGrow: 1,
            display: 'flex',
            order: { xs: 1, sm: 2 },
            mb: { xs: showSearchInput ? 2 : undefined, sm: 0 },
          }}
        >
          <SearchToolbarButtons
            buttons={buttons}
            showRefresh={showRefresh}
            onRefreshClick={onRefreshClick}
          />
        </Box>
      )}

      {Object.keys(searchFilters).length > 0 && (
        <Box
          sx={{
            order: showSearchInput ? 3 : 1,
            mt: showSearchInput ? 2 : undefined,
            flexBasis: showSearchInput ? '100%' : 'auto',
          }}
        >
          <SearchFilters excludedFilters={excludedFilters} />
        </Box>
      )}
    </Box>
  );
};

export default SearchToolbar;
